import { WorkspaceValidationError } from '@/services/workspaces/workspaceValidation'

export function applyCreateWorkspaceValidation(error, form) {
  if (!(error instanceof WorkspaceValidationError)) return false
  if (error.code === 'duplicate_name') form.setNameError(error.message)
  else form.setSubmitError(error.message)
  return true
}
